import firebase from "../../config/firebase";

export const getTutorials = (entries) => async (dispatch) => {
  try {
    dispatch(tutorialsLoader(true));

    let query = firebase.firestore().collection("tutorials");
    if (entries) {
      query = query.limit(entries);
    }

    const snapshot = await query.get();
    const tutorials = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    dispatch({ type: "GET_TUTORIALS", payload: tutorials });
  } catch (error) {
    console.error("Error fetching tutorials:", error);
  } finally {
    dispatch(tutorialsLoader(false));
  }
};

const tutorialsLoader = (loading) => async (dispatch) => {
  dispatch({
    type: "TUTORIALS_LOADER",
    payload: loading,
  });
};
